"use client";

import OtpInput from "react-otp-input";
import { useState, useTransition } from "react";
import { GenericButton } from "../general/button.component";
import { Spinner } from "@material-tailwind/react";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";

export const OTPverificationComponent = ({
	firstName,
	lastName,
	email,
	phoneNumber,
}: {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
}) => {
	const [otp, setOtp] = useState<string>("");
	const [isPending, startTransition] = useTransition();
	const router = useRouter();

	const handleOTPVerification = () => {
		startTransition(async () => {
			const res = await fetch("/api/auth/signin", {
				method: "POST",
				body: JSON.stringify({
					email,
					firstName,
					lastName,
					otp,
					phoneNumber,
				}),
			});
			if (res.status === 200) {
				router.push("/console/kyc");
			} else {
				toast.error("An error occured");
			}
		});
	};
	return (
    <div className="h-full grid grid-cols-1 place-content-center text-center">
      <div className="mb-8">
        <p className="font-semibold text-3xl text-primary">OTP Verification</p>
      </div>

      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        renderInput={(props) => <input {...props} />}
        containerStyle="flex justify-center items-center gap-2 md:gap-4 w-full mb-8"
        inputStyle="!w-[45px] md:!w-[72px] h-[40px] md:h-[60px] text-lg md:text-2xl font-medium text-text-dark border-[1px] border-[#D9D9D9] rounded-[8px] focus:outline-none focus:border-primary"
      />

      <div className="w-full md:w-[450px] mx-auto md:mt-3 mb-5">
        <GenericButton
          className="bg-secondary mx-auto !w-full disabled:bg-disabled"
          disabled={otp.length !== 6}
          onClick={handleOTPVerification}
        >
          {isPending ? (
            <div className="flex justify-center items-center gap-2">
              <Spinner className="w-6 h-6" {...({} as any)} />
              <p>Verifying</p>
            </div>
          ) : (
            "Verify"
          )}
        </GenericButton>
      </div>

      <p className="text-text-mid">
        Didn&apos;t receive OTP code?
        <span className="font-medium text-primary cursor-pointer ml-2 text-[17px]">
          Resend Now
        </span>
      </p>
    </div>
  );
};
